<template>
  <div class="page">
    <div class="container">

      <element-processor @submit="submit" :data="processorData" @submitOtherEst="submitOtherEst">
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>고객 정보</h3></li>
            
            <template v-if="false">
              <li><element-textbox v-model="processorData.steps[0].formData.name.value" :error="processorData.steps[0].formData.name.error" :label="processorData.steps[0].formData.name.label" :placeholder="processorData.steps[0].formData.name.label" /></li>
            </template>

            <li><element-spread-select v-model="processorData.steps[0].formData.sex.value" :error="processorData.steps[0].formData.sex.error" :label="processorData.steps[0].formData.sex.label" :items="processorData.steps[0].formData.sex.items" /></li>
            <li><element-textbox v-model="processorData.steps[0].formData.birth.value" :error="processorData.steps[0].formData.birth.error" :label="processorData.steps[0].formData.birth.label" :placeholder="processorData.steps[0].formData.birth.placeholder" /></li>
            <div class="form-item-caution">정확한 보험료 산출을 위해 활용됩니다.</div>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[1]">
          <ul class="form-item-list">
            <li><h3>보장항목</h3></li>
            <li><element-spread-select v-model="processorData.steps[1].formData.type.value" :error="processorData.steps[1].formData.type.error" :label="processorData.steps[1].formData.type.label" :items="processorData.steps[1].formData.type.items" :dropbox="processorData.steps[1].formData.type.dropbox"/></li>
            <li><element-select v-model="processorData.steps[1].formData.term.value" :error="processorData.steps[1].formData.term.error" :label="processorData.steps[1].formData.term.label" :items="processorData.steps[1].formData.term.items" :dropbox="processorData.steps[1].formData.term.dropbox"/></li>
            <li><element-textbox-auto-calculate :type="processorData.steps[1].formData.type.value" :year="processorData.steps[1].formData.term.items[processorData.steps[1].formData.term.items.findIndex(o => o.value == processorData.steps[1].formData.term.value)].year"
              v-model="processorData.steps[1].formData.payment.value" :mode="'pension'" :error="processorData.steps[1].formData.payment.error" :label="processorData.steps[1].formData.payment.label" :placeholder="processorData.steps[1].formData.payment.placeholder" /></li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[2]">
          <include-estimate-auth-self :data="processorData.steps[0]" @updateprocessorData="updateprocessorData" />
        </element-processor-step>

        <element-processor-step :data="processorData.steps[3]">
          <ul class="form-item-list">
            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[3].formData.consultDate.value" :error="processorData.steps[3].formData.consultDate.error" :label="processorData.steps[3].formData.consultDate.label" :placeholder="processorData.steps[3].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[3].formData.consultTime.value" :date="processorData.steps[3].formData.consultDate.value" :error="processorData.steps[3].formData.consultTime.error" :label="processorData.steps[3].formData.consultTime.label" :placeholder="processorData.steps[3].formData.consultTime.placeholder" />
            </li>
            <li><element-textarea v-model="processorData.steps[3].formData.consultRemark.value" :error="processorData.steps[3].formData.consultRemark.error" :label="processorData.steps[3].formData.consultRemark.label" :placeholder="processorData.steps[3].formData.consultRemark.placeholder" /></li>
            <li><div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div></li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[4]">
          <include-estimate-complete :data="processorData.steps[4]" />
        </element-processor-step>
        <element-processor-step :data="processorData.steps[5]">
          <include-other-estimate :data="processorData.steps[5]" :type="processorData.title"/>
        </element-processor-step>
      </element-processor>
    </div>
  </div>
</template>
<script>

import moment from 'moment';

export default {
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      moment: moment,
      processorData: {
        title: "연금보험 견적서",
        cureData: false,
        steps: [
          {
            title: "고객 정보",
            formData: {
              // name: {
              //   label: "이름",
              //   value: "",
              //   error: "",
              //   placeholder: "이름 입력",
              //   validations: [
              //     { type: "required", message: "필수항목입니다" }
              //   ]
              // },
              birth: {
                label: "생년월일",
                value: "",
                error: "",
                placeholder: "생년월일 6자리 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" },
                ]
              },
              sex: {
                label: "성별",
                value: "",
                error: "",
                items: [
                  { value: "남자", label: "남자" },
                  { value: "여자", label: "여자" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" },
                ]
              }
            }
          },
          {
            title: "보장항목",
            formData:
            {
              type: {
                label: "연금 종류",
                value: "연말정산 세액공제",
                error: "",
                dropbox: "연말정산 세액공제 : 최소 5년 이상 납입하고 만 55세 이후 한번에 받지 않고 10년 이상 연금으로 받는 조건으로 가입시 적용, 연금수령액 비관세 : 월 150만원 이내 보험료를 5년 이상 납부하고 연금을 받기 전까지 계약을 10년 이상 유지 시 적용",
                items: [
                  { value: "연말정산 세액공제", label: "연말정산 세액공제" },
                  { value: "연금수령액 비과세", label: "연금수령액 비과세" }
                ]
              },
              term: {
                label: "납입 기간",
                value: "60세",
                error: "",
                dropbox: "보험 가입자가 보험료 납입하는데 경제적으로 무리없는 기간을 선택하십시오. 연금보험은 보험료가 고액이기 때문에 경제 여유가 있는 시기에 납입하는 것이 합리적입니다. 중도 해지 시의 손실이 크다는 점도 감안하십시오.",
                items: [
                  { value: "10년", label: "10년", year: "10" },
                  { value: "15년", label: "15년", year: "15" },
                  { value: "20년", label: "20년", year: "20" },
                  { value: "60세", label: "60세", year: "60" }
                ]
              },
              payment: {
                label: "납입금액",
                value: [
                  { value: "" },
                  { value: "" },
                ],
                error: "",
                placeholder: [
                  { value: "0" },
                  { value: "0" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "float", message: "숫자만 입력가능합니다" }
                ]
              }
            }
          },
          {
            title: "본인 확인",
            formData: {
              // haslogin: {
              //   value: "",
              //   validations: [
              //     { type: "required", message: "-" }
              //   ]
              // },
              phone: {
                label: "휴대폰 번호",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              email: {
                label: "이메일",
                value: "",
                // validations: [
                //   { type: "required", message: "-" }
                // ]
              },
              birth: {
                label: "생년월일",
                value: "",
                validations: [
                  { type: "required", message: "-" },
                ]
              },
            }
          },
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ] // steps
      }
    }
  },
  created() {
    const { date, time } = this.$getDefaultConsultTime();

    if (date !== '') {
      this.processorData.steps[3].formData.consultDate.value = date;
    }

    this.processorData.steps[3].formData.consultTime.value = time;
  },
  methods: {
    submit( finalData ) {
      var tmp = JSON.parse(JSON.stringify(finalData["상담 예약"]));
      // 상담 예약 제거
      delete finalData["상담 예약"];
      //가입자 , 자필서명
      if(this.$route.query) {
        if(this.$route.query.procstep == "가입자" || this.$route.query.procstep == "본인 확인" || this.$route.query.procstep == "자필서명") {
          this.$store.dispatch( "estimate/createItems", finalData);
        }else if(this.$route.query.procstep == "상담 예약") {
          tmp.step_datas.insureName = { value: finalData.title }
          tmp.step_datas.name = {  value: this.processorData.steps[2].formData.name.value }
          tmp.step_datas.phone = { value: this.processorData.steps[2].formData.phone.value}
          var reservation_data = {
            customer_id: finalData.customer_id,
            "전화상담": tmp
          }
          // 전화상담 예약 전송
          this.$store.dispatch( "reservation/createItems", reservation_data );   
        }
      }
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    checkValue: function( value ) {
      var insureOptionsObj = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option];
      insureOptionsObj.items[this.statusPopup.index].subLabel = value;

      var Vidx = insureOptionsObj.value.findIndex(o => o.label === insureOptionsObj.items[this.statusPopup.index].label);
      if(Vidx >= 0){
        
        if(value === '미가입' && !insureOptionsObj.requirement){ 
          // 필수 보장항목이 아니고, 미가입하는경우는 value 목록에서 제거
          insureOptionsObj.value.splice(Vidx, 1);
        }else{
          // 이외 값 변경
          // 단, 값이 Array 인경우가 있으므로 확인 ( 다중선택 가능한경우 )
          if(Array.isArray(insureOptionsObj.value[Vidx].value)) {
            var VIidx = insureOptionsObj.value[Vidx].value.indexOf(value);
            // 이미 arr 값이 있는경우 제거
            if(VIidx >= 0){
              //단, 최소 하나이상 선택하도록 해야하므로
              if(insureOptionsObj.value[Vidx].value.length > 0) insureOptionsObj.value[Vidx].value.splice(VIidx, 1);
            }else{
              // 추가
              insureOptionsObj.value[Vidx].value.push(value)
            }
            insureOptionsObj.items[this.statusPopup.index].subLabel = insureOptionsObj.value[Vidx].value.join();
          }else{
            insureOptionsObj.value[Vidx].value = value;
          }
        }
      }else{
        // value 목록에 없는 경우
        if(value != '미가입'){
          // 미가입 아닌경우 값 추가
          var tmp = { label: insureOptionsObj.items[this.statusPopup.index].value, value: value };
          insureOptionsObj.value.push( tmp )
        }
      }
    },
    updateprocessorData: function (data){
      //this.processorData.steps[2].formData.haslogin.value = data.haslogin;
      this.processorData.steps[2].formData.phone.value = data.phone;
      this.processorData.steps[2].formData.name.value = data.name;
      this.processorData.steps[2].formData.email.value = data.email;
      this.processorData.steps[2].formData.birth.value = data.birth;
    },
    submitOtherEst() {
      var tmp = {
        customer_id: this.$store.state.customer.profile._id,
        "전화상담": {
          step_datas: {
            insureName: { value: "" },
            name: {  value: this.processorData.steps[2].formData.name.value },
            phone: { value: this.processorData.steps[2].formData.phone.value },
            consultDate: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultDate.value },
            consultTime: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultTime.value },
            consultRemark: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value ? this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value : "없음"}
          }
        }
      }
      var ost_data = this.processorData.steps[this.processorData.steps.length - 1];
      if(ost_data.value.length > 0) {
        ost_data.value.forEach(o => {
          tmp["전화상담"].step_datas.insureName.value = o
          this.$store.dispatch( "reservation/createItems", tmp );
        })
      }
    }
  }
}
</script>
